import React from 'react';
import { Box, Typography, IconButton, Stack } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import theme from '../../theme';

const getStarIcons = (value) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    if (value >= i) {
      stars.push('full');
    } else if (value >= i - 0.5) {
      stars.push('half');
    } else {
      stars.push('empty');
    }
  }
  return stars;
};

const Rating = ({ value = 0, onChange, readOnly = false }) => {
  const stars = getStarIcons(value);

  const handleClick = (idx, e) => {
    if (!onChange || readOnly) return;
    const rect = e.target.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const isHalf = x < rect.width / 2;
    const newValue = isHalf ? idx + 0.5 : idx + 1;
    onChange(newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Stack direction="row" spacing={{ xs: 0.5, lg: 0 }}>
        {stars.map((type, idx) => (
          <IconButton
            key={idx}
            disableRipple
            sx={{
              p: 0,
              color: theme.palette.secondary.main,
              '&:hover': {
                backgroundColor: 'transparent',
              },
              cursor: readOnly ? 'default' : 'pointer',
            }}
            onClick={(e) => handleClick(idx, e)}
          >
            {type === 'full' ? (
              <StarIcon sx={{ fontSize: { xs: 24, lg: 20 } }} />
            ) : type === 'half' ? (
              <Box
                sx={{
                  position: 'relative',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: { xs: 24, lg: 20 },
                  width: { xs: 24, lg: 20 },
                  lineHeight: 0,
                }}
              >
                <StarBorderIcon
                  sx={{
                    color: theme.palette.grey.line,
                    fontSize: { xs: 24, lg: 20 },
                    position: 'absolute',
                  }}
                />
                <StarIcon
                  sx={{
                    fontSize: { xs: 24, lg: 20 },
                    position: 'absolute',
                    clipPath: 'inset(0 50% 0 0)',
                  }}
                />
              </Box>
            ) : (
              <StarBorderIcon
                sx={{ color: theme.palette.grey.line, fontSize: { xs: 24, lg: 20 } }}
              />
            )}
          </IconButton>
        ))}
      </Stack>
      <Typography color={theme.palette.black[4]} fontSize={14} sx={{ ml: 0.5 }}>
        ({(value || 0).toFixed(1)})
      </Typography>
    </Box>
  );
};

export default Rating;
